export const rowStructuresEnum = {
    DataTableRowStructures: 1,
    PostazioneRowStructures: 2,
    UserRowStructures: 3,
    RichiesteAccessoRowStructures: 4,
}